import { render, staticRenderFns } from "./epc_autoBrands.vue?vue&type=template&id=5a992abc&scoped=true&"
import script from "./epc_autoBrands.vue?vue&type=script&lang=js&"
export * from "./epc_autoBrands.vue?vue&type=script&lang=js&"
import style0 from "./epc_autoBrands.vue?vue&type=style&index=0&id=5a992abc&lang=less&scoped=true&"
import style1 from "./epc_autoBrands.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a992abc",
  null
  
)

component.options.__file = "epc_autoBrands.vue"
export default component.exports